<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  TreatmentWizard(
    v-show="!isSubmitting",
    :data="treatmentData",
    :on-save-draft="saveDraft",
    :isEdit="true",
    @submit="update"
  )
</template>

<script>
import TreatmentWizard from '../shared/TreatmentWizard.vue'
import useTreatmentEdit from './useTreatmentEdit'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { onMounted } from '@vue/composition-api'

export default {
  components: {
    TreatmentWizard,
    Loading,
  },
  setup() {
    const { update, saveDraft, treatmentData, isSubmitting, show } = useTreatmentEdit()

    onMounted(show)

    return {
      update,
      saveDraft,
      treatmentData,
      isSubmitting,
    }
  },
}
</script>
